import { FC } from 'react';
import { VehicleManageForm } from '@components/portal/vehicle-list';

export const EditVehicle: FC = () => {
	return <VehicleManageForm mode="edit" />;
};
